export default __webpack_public_path__ + "static/qrCode-a85e8de8d11161551348ae8d41e162ff.svg";